import { get, post, put } from '@/api/index'


// https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/orderlist
export const addressList = params => {
  return get('https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/address', params)
}
// https://ecapi.yinmakeji.com/api/h5app/wxapp/espier/address
export const cityList = params => {
  return get('https://ecapi.yinmakeji.com/api/h5app/wxapp/espier/address', params)
}
// https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/address
export const addAddress = params => {
  return post('https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/address', params)
}
// https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/addressidentify
export const checkAddress = params => {
  return post('https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/addressidentify', params)
}
// https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/address/del
export const deleteItem = params => {
  return post('https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/address/del', params)
}
// https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/addressinfo
export const addressinfo = params => {
  return get('https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/addressinfo', params)
}
// https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/address
export const updateAddress = params => {
  return put('https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/address', params)
}
